<template>
    <div class="quiz__nav" :class="{ 'quiz__nav_lifestyles': viewing_lifestyles }">
        <button @click="back" class="quiz__nav-btn back">Back</button>
        <button @click="next" class="quiz__nav-btn next" :class="{ 'invisible': answer_needed }" v-if="user_can_progress">Next</button>
        <button @click="next" class="quiz__nav-btn next quiz__nav-btn_lifestyles" :class="{ 'invisible': answer_needed }" v-if="user_can_see_results">see results</button>
    </div>
</template>

<script>
import { bus, isObject } from '../utilities'
import { analytics } from 'shiseido-apis'

export default {
    data() {
        return {
            answer: null,
        }
    },
    computed: {
        answer_needed() {
            return !isObject(this.answer)
        },
        viewing_lifestyles() {
            return this.$route.name === 'lifestyle'
        },
        viewing_coverage_options() {
            return this.$route.name === 'coverage'
        },
        user_can_progress() {
            return !this.viewing_lifestyles && !this.viewing_coverage_options
        },
        user_can_see_results() {
            return this.viewing_lifestyles || this.viewing_coverage_options
        },
    },
    created() {
        bus.$on('answer::chosen', (answer) => {
            this.answer = answer
        })
    },
    methods: {
        next() {
            if (!this.answer_needed) {
                analytics.registerClick({
                    element: 'next',
                    toolname: 'Gift Guide',
                    question: this.$route.name,
                    answers: [this.answer.text],
                })

                const answer = this.answer.text.replace('/', '_')
                const next_path = `${ this.$route.path }/${ answer }`.replace(/\/\//g, '/')

                bus.$emit('next', { path: next_path })
            }
        },
        back() {
            analytics.registerClick({
                element: 'back',
                toolname: 'Gift Guide',
                question: this.$route.name,
                answers: [],
            })

            if (this.$route.name === 'who') {
                bus.$emit('next', { path: '/' })
            } else {
                const curr_path  = this.$route.fullPath.replace(/\/$/, '')
                const curr_steps = curr_path.split('/')
                const prev_steps = curr_steps.slice(0, -1)
                const next_path  = prev_steps.join('/')

                bus.$emit('next', { path: next_path })
            }
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/js/app/components/quiz-navigation.vue